import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LucideIconsModule } from '@shared/lucide-icons.module';

export type PayButtonVariant = 'primary' | 'secondary' | 'info' | 'danger' | 'text' | 'ghost' | 'white';
export type PayButtonSize    = 'default' | 'sm';

@Component({
  selector:    'pay-button',
  standalone:  true,
  imports:     [CommonModule, LucideIconsModule],
  templateUrl: './pay-button.component.html',
  styleUrls:   ['./pay-button.component.scss'],
})
export class PayButtonComponent {
  @Input() variant:      PayButtonVariant = 'primary';
  @Input() size:         PayButtonSize    = 'default';
  @Input() label:        string           = '';
  @Input() icon?:        string;
  @Input() iconPosition: 'left' | 'right' = 'left';
  @Input() disabled:     boolean          = false;
  @Input() loading:      boolean          = false;
  @Input() type:         'button' | 'submit' | 'reset' = 'button';

  @Output() clicked = new EventEmitter<MouseEvent>();

  get isIconOnly(): boolean {
    return !!this.icon && !this.label;
  }

  get hostClasses(): string {
    const base    = 'pay-btn';
    // icon-only buttons are always ghost — no bg, no border, just the icon
    const variant = `pay-btn--${this.isIconOnly ? 'ghost' : this.variant}`;
    const size    = this.size === 'sm' ? 'pay-btn--sm' : '';
    const busy    = this.loading  ? 'pay-btn--loading'  : '';
    const off     = this.disabled ? 'pay-btn--disabled' : '';
    return [base, variant, size, busy, off].filter(Boolean).join(' ');
  }

  get iconSize(): number {
    return this.size === 'sm' ? 13 : 14;
  }

  get spinnerIcon(): string {
    return 'refresh-cw';
  }

  onClick(event: MouseEvent): void {
    if (!this.disabled && !this.loading) {
      this.clicked.emit(event);
    }
  }
}
